<div class="print-dialog-container">
  <h2 mat-dialog-title class="dialog-title">
    <i class="fa fa-print"></i>
    Impression des codes-barres
  </h2>

  <mat-dialog-content class="dialog-content">

    <!-- Controls -->
    <div class="print-controls">

      <!-- Row 1: Copies + Format on same line -->
      <div class="controls-row">

        <!-- Copies -->
        <div class="control-block">
          <span class="control-label">Tickets / produit</span>
          <div class="copies-input-wrapper">
            <button class="copies-btn" type="button"
              (click)="copies = copies > 1 ? copies - 1 : 1; onCopiesChange()">−</button>
            <input
              id="copiesInput"
              type="number"
              class="copies-input"
              [(ngModel)]="copies"
              min="1"
              max="200"
              (change)="onCopiesChange()"
            />
            <button class="copies-btn" type="button"
              (click)="copies = copies + 1; onCopiesChange()">+</button>
          </div>
        </div>

        <!-- Divider -->
        <div class="controls-divider"></div>

        <!-- Format -->
        <div class="control-block">
          <span class="control-label">Format étiquette</span>
          <div class="size-selector">
            <button
              *ngFor="let s of labelSizes"
              class="size-btn"
              [class.active]="s.id === selectedSize.id"
              type="button"
              (click)="selectSize(s)">
              {{ s.label }}
            </button>
            <button
              class="set-default-btn"
              type="button"
              (click)="setAsDefault()"
              [class.saved]="defaultSaved"
              [title]="defaultSaved ? 'Enregistré !' : 'Définir comme format par défaut'">
              <i class="fa" [ngClass]="defaultSaved ? 'fa-check' : 'fa-bookmark'"></i>
            </button>
          </div>
        </div>

        <!-- Summary -->
        <div class="summary-badge">
          <i class="fa fa-tags"></i>
          {{ totalLabels }} étiq. &bull; {{ products.length }} produit(s)
        </div>

      </div>
    </div>

    <!-- Preview -->
    <div class="preview-section">
      <div class="preview-title">
        <i class="fa fa-eye"></i> Aperçu &mdash; {{ selectedSize.label }}
      </div>
      <div class="labels-preview">
        <div
          *ngFor="let item of labelItems"
          class="label-preview"
          [class.is-small]="selectedSize.id === '30x15'"
          [style.width.px]="selectedSize.previewW"
          [style.height.px]="selectedSize.previewH">
          <!-- 50x25: show full name + price -->
          <div
            *ngIf="selectedSize.id !== '30x15'"
            class="label-product-name"
            [title]="(item.product.price != null ? item.product.price + ' DH - ' : '') + (item.product.name ?? '')">
            {{ item.product.price != null ? item.product.price + ' DH - ' : '' }}{{ item.product.name }}
          </div>
          <div class="label-barcode" [innerHTML]="item.barcodeSvg"></div>
          <!-- 30x15: show only price + barcode number (no product name) -->
          <div
            *ngIf="selectedSize.id === '30x15'"
            class="label-code-only">
            {{ item.product.price != null ? item.product.price + ' DH  ' : '' }}{{ item.product.codeBare }}
          </div>
        </div>
        <div *ngIf="labelItems.length === 0" class="no-labels">
          Aucune étiquette à afficher
        </div>
      </div>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close class="cancel-btn">
      <i class="fa fa-times"></i> Annuler
    </button>
    <button mat-raised-button class="print-btn" (click)="printLabels()" [disabled]="isPrinting">
      <ng-container *ngIf="!isPrinting">
        <i class="fa fa-print"></i>
        Imprimer {{ totalLabels }} étiquette(s)
      </ng-container>
      <ng-container *ngIf="isPrinting">
        <i class="fa fa-spinner fa-spin"></i>
        Impression en cours...
      </ng-container>
    </button>
  </mat-dialog-actions>
</div>
